module.exports = __webpack_public_path__ + "static/media/team-placeholder.70a80a94.png";